export default "__VITE_ASSET__K97acUFt__"